export default {
  meEndpoint: `${process.env.REACT_APP_API_URL}/staff/find/`,
  loginEndpoint: `${process.env.REACT_APP_API_URL}/staff/login`,
  registerEndpoint: `${process.env.REACT_APP_API_URL}/staff`,
  reissueEndpoint: `${process.env.REACT_APP_API_URL}/staff/reissue`
}